import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { BbitWebShopCartService, BbitWebShopFormatPricePipe, BbitWebShopService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteMetaDataService, BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { ItemImageComponent } from '../../helper/item-image/item-image.component';
import { ItemPriceComponent } from '../../helper/item-price/item-price.component';
import { ItemStockComponent } from '../../helper/item-stock/item-stock.component';
import { LoadingComponent } from '../../helper/loading/loading.component';
import { QuantityInputComponent } from '../../helper/quantity-input/quantity-input.component';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    RouterLink,
    ItemStockComponent,
    QuantityInputComponent,
    NgIcon,
    LoadingComponent,
    AsyncPipe,
    I18nPipe,
    ItemStockComponent,
    BbitWebShopFormatPricePipe,
    ItemPriceComponent,
    LoadingComponent,
    ItemImageComponent,
  ],
})
export class CartComponent {
  cart = inject(BbitWebShopCartService);
  website = inject(BbitWebsiteService);
  webShop = inject(BbitWebShopService);

  constructor(meta: BbitWebsiteMetaDataService) {
    meta.update({ title: { key: 'cart' } });
  }
}
